<template>
<div class="page">
  <div style="inline-block">
    <h3>ПРИЕМ ПАЦИЕНТА</h3>
  </div>
  <div style="display: flex; justify-content:space-between;">  

    <div class="today">
      <searchInput v-model="poisk"/>
    <!--div style="display:flex; width:100%">
      <div class="backInp">
        <input id="searching" class="searching" placeholder="Поиск..." v-model="poisk" />
      </div>
        <span class="material-icons searhIcon" v-bind:style="searchIcon">search</span>
    </div-->
    <vmbutton @click="isFilter=true" style="position:relative; top:80px; right:50px; display:flex; justify-content:flex-end;"> Фильтр </vmbutton>
      <filterSearch v-if="isFilter" :selected="searchFiltr" @close="closeFilter($event)" />
    <div class="timeDate" style="position:relative; bottom:50px">
      <svg xmlns="http://www.w3.org/2000/svg" style="z-index: 2; filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));" width="114" height="115" viewBox="0 0 36 36" >
    
        <circle fill="#E6C9F7" cx="18" cy="18" r="18"/><circle fill="#A32CDF" cx="18" cy="18" r="16"/><circle fill="#E1E8ED" cx="18" cy="18" r="14"/>
        <circle fill="#A32CDF" cx="18" cy="18" r="2"/>
        <line id="hours" x1="0" y1="0" x2="0" y2="8" stroke-linecap="round"    stroke-width="2" stroke="#A32CDF" transform="translate(18,18) rotate(180 0 0) " /> 
        <line  id="minutes" x1="0" y1="0" x2="0" y2="12" stroke-linecap="round"    stroke-width="2" stroke="#A32CDF" transform="translate(18,18) rotate(258 0 0) " />
        <line id="seconds" x1="0" y1="0" x2="0" y2="12" stroke-linecap="round"    stroke-width="1" stroke="#fff" transform="translate(18,18) rotate(310 0 0) " />
      </svg>
      <div class="currentDay">
        {{Today()}}
      </div>
      <div class="backDate">
        <img width="178" height="178" src="@app/images/svg/manyPoints.svg" alt />
      </div>
      <!--clock /-->
    </div>
    </div>
    <div style="display:flex; align-items:center;">
      <calendar @chooseDay="chooseDay($event)"/>
      </div>
  </div>
  
  <div>
    <div class="wrap">
      <v-select style="border-radius:25px" v-if="isOrgadmin"
      :options="doctors"
      label="text"
      placeholder="Выберите врача..."
      @keyup.native="getDoctors($event.target.value)"
      @input="getEmployeeSlots($event)"
      @search:focus="getDoctors('')"
      >
          <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                  Не найдено: <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Начните набирать...</em>
          </template>
          <template slot="option" slot-scope="option" :value="option.value">
              <div> {{option.text}}</div>
          </template>
      </v-select>
      <ul class="backoff">
        
        <ul class="backoff" v-for="slot in filtered"  :key="slot.id"

        > 
          <div class="list-header">
            <span style="margin-left:.5rem; font-style: italic"> {{slot.specialty}} </span>
          </div>
          <li >
            <div class="list-post-header">
                <span class="wd">Пациент</span>
                <span class="wd">Карта</span>
                <span class="wd">Время</span>
                <span class="wd">Статус</span>
                <span style="width:25%; text-align:center">Действия</span>
            </div>
        </li>
        <div v-if="slot.slots.length > 0">

          <li v-for="patient in slot.slots" :key="patient.id"
           
          
          > <!--'v-bind:style="listClass(patient)"'-->
          <div class="list-patients" :class="{ cancelPatient: patient.status=='Прием отменен', donePatient: patient.status=='Прием проведен'}" >
            <span class="wd"> {{patient.last_name}} {{patient.first_name}} </span>
            <span class="wd" v-if="patient.cardid"> № {{patient.cardid}} </span> <span class="wd" v-else> - </span>

            <span class="wd"> {{ patient.start_time | formDate}} - {{patient.end_time | formDate}} </span>  
            <!--span class="wd" v-if="patient.reception">Прием прошел</span>
            <span class="wd" v-else> <template v-if="patient.status=='Запись отменена'"> Прием отменен </template-->
            <span class="wd"> {{patient.status}} </span>
            <div style="display:flex; justify-content:space-around; width:25%">
            
            <!--button class="btn btn-bg btn-danger waves-effect waves-light m-t-10 m-b-10 action"
            v-bind:disabled="patient.reception" 
            @click="editStatus(patient.status, patient.id)"
            >
              <template v-if="patient.status=='Прием отменен'"> <span class="material-icons">restore</span> </template> 
              <template v-else> <span class="material-icons">clear</span> </template>
            </button-->
            <button class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10 action"
            v-b-tooltip.hover.left="'Редактировать карточку'"
            @click="editCardPatient(patient)"
            >
                <span class="material-icons">assignment</span>
            </button>
            <button class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10 action"
            @click.prevent="preJoinReception(patient, slot)"
            v-bind:disabled="patient.status=='Прием отменен'"
            v-b-tooltip.hover.right :title="'Принять пациента'"
            v-if="isDoctor"
            >
              <span class="material-icons">done</span>
            </button>
            </div>
            <span v-if="patient.conversation" v-b-tooltip.hover.right :title="'Пациент выбрал видеоконсультацию'" class="material-icons">videocam</span>
            <span v-else v-b-tooltip.hover.right :title="'Пациент будет очно'" class="material-icons">record_voice_over</span>
          </div>
          </li> 
        </div> 
        <li class="list-group-item list-group-custom" v-else> Записей нет </li>
        </ul>
      </ul>
    </div>
  </div>
  <confirm
  v-if="confirmOpen" 
  @close="confirmOpen = false"
  @success="$router.push({name: 'registry.patient.card', params: {uuidPatient: confirmPatient.id, item: confirmPatient, prev: 'reception'}})"
  />

  <confirm v-if="confirmFormReception"

  >
    <div slot="header" style="font-weight:600">
      Выберите форму приема:
    </div>
    <div slot="body" style="max-height:90vh">
      <b-form-group class="formReception" vertical>
        <label>Основные формы приема: </label>
        <b-form-checkbox-group class="formReception" stacked buttons button-variant="outline-primary"
          :options="main_forms" v-model="selected_forms"
         >
         </b-form-checkbox-group>
      </b-form-group>
      <div class="formReception" style="display:flex; flex-direction:column">
        <label>Избранные формы приема: </label>
        <b-button-group vertical style="width:100%">
        <!--b-form-checkbox-group class="formReception" v-model="selected_forms"
        stacked buttons button-variant="outline-primary" :options="other_forms"><span class="material-icons">close</span>
        </b-form-checkbox-group-->
        <b-form-checkbox class="formList" @input="changeSelectedForms($event, formd)"
        button button-variant="outline-primary" v-for="formd in other_forms" :key="formd.id">{{formd.text}}<span @click.stop.prevent="removeFavour(formd.id)" class="material-icons delfav">close</span>
        </b-form-checkbox>
        </b-button-group>
      </div>
      <div style="margin-top:1rem">
      <b-button v-b-toggle.collapse-1 variant="secondary">Формы <span class="material-icons" style="vertical-align:middle">keyboard_arrow_down</span></b-button>
      <b-collapse id="collapse-1" class="mt-2">
        <b-card>
          <ul>
            <li class="vm-list" v-for="form in forms" :key="form.id">
                <span>{{form.text}}</span> <b-button @click="addToFavour(form.id)" v-b-tooltip.hover :title="'добавить в избранное'" variant="info" style="display:flex; margin-left:auto; padding-top:0"><span class="material-icons">playlist_add</span></b-button>
            </li>
          </ul>
        </b-card>
      </b-collapse>
    </div>
    </div>
    <div slot="footer">
      <button class="btn btn-sm btn-secondary" @click="confirmFormReception=false">
                    Отмена
      </button>
      <button class="btn btn-sm btn-info" style="margin-left:10px" :disabled="selected_forms.length <= 0"
         @click="goToCurrentPatient($store.state.reception.current_patient.patient, selected_forms)" >
        Перейти
      </button>

    </div>
  </confirm>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import helper from '../../../services/helper';
import clock from '../components/oclock';
import { receptionApi, employeeApi, patientApi, doctorApi, favFormsApi } from '../../../services';
import calendar from '../components/calendar';
import confirm from '../components/confirmation';
import searchInput from '@app/components/uikit/searchInput';
import vmbutton from '@app/components/uikit/VMButton';
import filterSearch from '@app/components/filter';
import { debounce } from 'lodash';

  export default {
    components: {
 //     clock,
      calendar,
      searchInput,
      vmbutton,
      filterSearch,
      confirm
    },
    data() {
      return {
        poisk: '',
        chosenDate: new Date(),
        searchIcon: '',
        interval: '',
        isFilter: false,
        searchFiltr: ['patient', 'cardid', 'birthday', 'phone'],
        isOrgadmin: false,
        isDoctor: false,
        doctors: [],
        confirmOpen: false,
        confirmPatient: '',
        employee_uuid: this.$store.state.permission.resources.organization[this.$store.state.clinic.id].bindings.employee,
        confirmFormReception: false,
        main_forms: [
            { text: 'Форма 025/у', value: 0 }
        ],
        other_forms: [],
        selected_forms: [],
        forms: [],
        chosenDoctor: ''
      };
    },
    computed: {...mapGetters(['allSlots']),
      filtered() {
        let str = this.poisk;
        let list = [];
        this.allSlots.forEach(obj => {
          list.push(Object.assign({}, obj));
        });
        return list.filter(slot => {
            slot.slots = slot.slots.filter(pat => { 
              if (str==='') { return true; } else {
                if (this.$data.searchFiltr.includes('patient')) {
                  return pat.last_name.indexOf(str) > -1 || pat.first_name.indexOf(str) > -1;
                }
              }
            });
          return true;
        });
      }
    },
    async mounted() { this.init();
     // const employee_uuid = this.$store.state.permission.resources.organization[this.$store.state.clinic.id].bindings.employee;
      if (!this.$store.state.permission.resources.organization[this.$store.state.clinic.id].roles.includes('doctor')) {
        this.employee_uuid = null;
      } else {
        this.$store.dispatch('getSlots', { emp: this.employee_uuid, dat: this.$data.chosenDate});
      }
      this.isOrgadmin = this.$store.state.permission.resources.organization[this.$store.state.clinic.id].roles.includes('orgadmin');
      this.isDoctor = this.$store.state.permission.resources.organization[this.$store.state.clinic.id].roles.includes('doctor');
    },
    methods: {
      ...mapActions(['clearSlots']),
      changeSelectedForms(evt, form) {
        if (evt) {
          this.selected_forms.push(form.value);
        } else {
          this.selected_forms = this.selected_forms.filter(obj => obj.id !== form.value.id);
        }
      },
      async removeFavour(id) {
        await favFormsApi.remove(null, { doctor: this.chosenDoctor, form_id: id}).then(res => {
          const favobj = this.other_forms.find(f => f.id === id);
          this.forms.push(favobj);
          this.other_forms = this.other_forms.filter(f => {
            if(f.id !== id) {
              return f;
            }
          });
        });
        
      },
      async addToFavour(id) {
        await favFormsApi.create(null, { doctor: this.chosenDoctor, form_id: id}).then(res => {
        const favobj = this.forms.find(f => f.id === id);
                this.other_forms.push(favobj);
                this.forms = this.forms.filter(f => {
                  if(f.id !== id) {
                    return f;
                  }
                });
        });
        
      },
      async preJoinReception(patient, slot) {
        this.chosenDoctor = slot.doctor;
        await favFormsApi.getAll(null, null, null, null, { doctor: slot.doctor }).then(res => {
          this.other_forms = res.items.map(({ id, title }) => ({
        id,
        text: title,
        value: { title, id}
      }));
        });
        axios
        .get('/api/get_form_list/')
        .then(response => {
          this.forms = response.data.map(({ id, title }) => ({
        id,
        text: title,
        value: { title, id}
      }));
      this.other_forms.forEach(obj => {
        this.forms = this.forms.filter(f => {
          if (obj.id !== f.id) {
            return f;
          }
        });
      });
        })
        .catch(error => {
          //console.log(error);
        });
        this.confirmFormReception = true;
        this.$store.state.reception.current_patient.patient = patient;
      },
      goToCurrentPatient(patient, selected_forms) {
        if (patient) {
          if (patient.cardid) {
            this.$router.push({name:'currentpatient', params: { selected_forms }});
            this.$store.dispatch('getCurrentPatient', patient);
          } else {
            patientApi.get(patient.patient).then(pat => {
              this.confirmFormReception = false;
              this.confirmPatient = pat;
              this.confirmOpen = true;
            });
          }
        }
      },
      editCardPatient(patient) {
        patientApi.get(patient.patient).then(pat => {
               this.$router.push({name: 'registry.patient.card', params: {uuidPatient: pat.id, item: pat, prev: 'reception'}});
            });
      },
      listClass(patient) {
        let clasStyle = {cursor: 'default'};
        if (patient) {
          clasStyle.cursor = 'pointer';
          if (patient.reception) {
            clasStyle['background'] = 'linear-gradient(to bottom right, #b7e1f3, #e4f0f5)';
          } else {
            if (patient.status === 'Запись отменена') {
             clasStyle['background'] = 'linear-gradient(to bottom right, #f09e9e, #e4f0f5)';
            } else {
              clasStyle['background'] = 'linear-gradient(to bottom right, #b9f3b7, #e9f5e4)';
            }
          }
        }
        return clasStyle;
      },
      Today() {
        const date = new Date(this.$data.chosenDate);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return date.toLocaleDateString('ru-RU', options);
      },
      editStatus(status, uuid) { console.log(status, uuid);
      if (status === 'Запись произведена') {
        status = 'Запись отменена';
      } else if (status === 'Запись отменена') {
        status = 'Запись произведена';
      }
      const employee_uuid = this.$store.state.permission.resources.organization[this.$store.state.clinic.id].bindings.employee;
      receptionApi.editStatus(status, uuid).then(res => {
        this.$store.dispatch('getSlots', { emp: employee_uuid, dat: this.$data.chosenDate});

      });
      },
         init(evt) {
          let 
            svgHours   = document.querySelector('#hours'),
            svgMinutes = document.querySelector('#minutes'),
            svgSeconds = document.querySelector('#seconds');
              
            this.$data.interval = setInterval(() => {
            let  dt = new Date(),
            hours = dt.getHours(),
            minutes = dt.getMinutes(),
            seconds = dt.getSeconds(),
            degSeconds = 180 + 360/60 * seconds,
            degMinutes = 180 + 360/60 * minutes,
            degHours =   180 + 360/12 * ( hours % 12 ) + degMinutes/60;
            

            svgHours.setAttribute('transform',`translate(18,18) rotate(${degHours} 0 0)`);
            svgMinutes.setAttribute('transform',`translate(18,18) rotate(${degMinutes} 0 0)`);
            svgSeconds.setAttribute('transform',`translate(18,18) rotate(${degSeconds} 0 0)`);
          }, 1000);
            
          },
      chooseDay(evt) {
        this.$data.chosenDate = new Date(new Date().getFullYear() + '-' + evt.month + '-' + evt.day);
      },
      closeFilter(evt) {
        this.$data.isFilter = false;
        this.$data.searchFiltr = evt;
      },
      getEmployeeSlots(evt) {
        if (evt) {
          this.employee_uuid = evt.value;
          this.$store.dispatch('getSlots', { emp: this.employee_uuid, dat: this.$data.chosenDate});
        }

      },
      getDoctors: debounce(function (str) {
              employeeApi.getAll(undefined, undefined, undefined).then(docs => {
          this.doctors = docs.items.map(item => {
              const text = `${item.firstName} ${item.lastName} ${item.middleName}`;
              const value = item.id;
              return { text, value };
            });
        });
        }, 500),
      
    },
    destroyed() {
      clearInterval(this.$data.interval);
      this.clearSlots();
    },
    watch: {
      chosenDate () {
        this.$store.dispatch('getSlots', { emp: this.employee_uuid, dat: this.$data.chosenDate});
      },
      searchIcon() {
        const leng = document.getElementById('searching').clientWidth;
        console.log(leng);
        return { 'margin-left': leng/1.2 + 'px'};
      },
     
    },
    filters: {
      formDate(str) {
        if (str) {
          return new Date(str).getHours() + ':' + ((new Date(str).getMinutes() === 0) ? '00' : new Date(str).getMinutes()); //helper.formatDateTime(str).split(' ')[1];
        }
      },
      uppercase(value) {
        if (!value) { return ''; }
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    } 

  };
</script>

<style lang="scss" scoped>

.thetime {
  width: 150px;
}
.page-wrap {
  /* padding-top: 92px; */
  min-height: 54.3vh;
  box-sizing: border-box;
}

.list-group-item {
  background-color: transparent;
}
.list-group-custom {
  display: flex;
  padding: 0;
  //padding-left: 1rem;
  align-items: center;
  height: 45px;
  justify-content: space-around;
}
/*.list-group-custom:hover {
  background-color: green;
}*/
.list-group-item {
  border: 0;
  border-bottom: 1px solid #dfdfdf;
  font-weight: 400;
}
.list-group-header {
  font-weight: bold;
  font-size: 1rem;
  height: 45px;
  font-weight: 600;
  background: white;
}
.list-header {
  background: linear-gradient(to right, #8C30DA 260px, #5C48D4);
  color: white;
  width:100%; 
  border-radius:10px;
  margin-bottom: 2px;
  opacity: 0.35;
}
.list-post-header {
  background: white;
  color: black;
  width:100%; 
  border-radius: 10px;
  box-shadow: 0 0 1px #8C30DA;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 5px;
}
.list-patients {
  background: #E1E8ED;
  color: black;
  width:100%; 
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 5px;
  margin-left: 0;
  margin-right: 0;
  box-shadow: 0 0 1px #8C30DA;
}
.backoff {
  background: #F2F1F2;
  padding: 0;
  outline: none;
}
li {
  display: flex;
}
.list-group-header,
.list-group-item:last-child {
  border-radius: 0;
}
.list-group-header .actions {
  margin-left: auto;
  display: block;
  line-height: 36px;
  text-align: center;
  width: 120px;
  padding: 0 0.8rem;
}

.vm-card {
  position: relative;
  box-shadow: 0 2px 1px -1px linear-gradient(to right, #8C30DA 260px, #5C48D4), 0 1px 1px 0 linear-gradient(to right, #8C30DA 260px, #5C48D4), 0 1px 3px 0 linear-gradient(to right, #8C30DA 260px, #5C48D4);
}
.vm-card .overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.today {
  padding-left: 2rem;
  padding-bottom: .5rem;
  border-bottom: 2px solid rgba(0,0,0,.05); 
  width: 100%;
}
.searching {
  border-radius: 25px;
  background:#fff;  
  position: relative;
  width: 100%;
  border: none;
  height: 90%;
  align-self: center;
  padding: 15px;
}
.searching:focus {
  outline: none;
}
.backInp {
  border-radius: 25px;
  background: linear-gradient(to right, #8C30DA 260px, #5C48D4);
  height: 55px;
  display: flex;
  justify-content: center;
  align-content: center;
  padding-left: 3px;
  padding-right: 3px;
  width: 100%;
  box-shadow: 0 0 5px#8C30DA;
}
.searhIcon {
  /*width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  margin-right: -26px;
  position: absolute;
  z-index: 1;
  float: right; */
  position: relative;
  right: 38px;
  align-self: center;
}
.searhIcon + input {
  padding-right: 26px;
}
h3 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 29.3939px;
  line-height: 34px;
  color: #36234D;
  max-width: 420px;
  width: 100%;
  position: relative;
  display: inline-block;
}
.timeDate {
  display: flex;
  height: 135px;
  padding-top: 20px;
}
.currentDay {
      width:200px; height: 60px; position:relative; right: 75px; border-radius:32px;
      align-self:flex-end; display:flex; justify-content:flex-end; align-items:center; color:white;
      padding: 25px; font-size:20px;
      background: linear-gradient(to right, #8C30DA, #5C48D4); z-index: 1;
  filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));

}

.backDate {
  width: 178px;
  height: 178px;
  position: relative;
  right: 310px;
  bottom: 25px;
}

.action {
  padding: 0;
  height: 26px;
}

::v-deep .vm-base {
  padding-left:50px; padding-right:50px
}

.wd {
  width: 25%;
  text-align: center;
}
.material-icons {
  cursor: pointer;
}
.formReception {
  width: 100%;
}
::v-deep .btn-outline-primary {
  width: 100%;
}
.cancelPatient {
  background: #EFE89D;
}
.donePatient {
  background: #a0f811b0;
}
.vm-list {
  height: 35px;
  display: flex;
  border-bottom: 1px solid gray;
  margin:5px;
  padding:5px;
}
.delfav {
  display:inline;
  opacity: 0;
  vertical-align: bottom;
  float: right;
}
.formList {
  width: 100%;
}
.formList:hover {

  .delfav {
    opacity: 1;
  }
  .delfav:hover {
    color: black;
  }
}

</style>